import { CircleAlert, TriangleAlert } from "lucide-react";
import { t } from "../i18n/t";

/**
 * §B2.3/§B6.6: a banner is not dismissible unless the caller says so, and it names its own severity in words.
 * §3 alert banner: 18 px leading icon (`circle-alert` blocking, `triangle-alert` warning; the info tone names no
 * icon in the design, so it renders none).
 */
export function Banner({
  tone,
  title,
  action,
  children,
}: {
  tone: "info" | "warn" | "block";
  title?: string;
  /** §3: an optional compact action button on the right (warn: `--color-warn-border` border). */
  action?: React.ReactNode;
  children: React.ReactNode;
}): JSX.Element {
  const label = tone === "info" ? t("banner.info") : tone === "warn" ? t("banner.warn") : t("banner.block");
  const Icon = tone === "block" ? CircleAlert : tone === "warn" ? TriangleAlert : null;
  return (
    <div className={`banner banner--${tone}`} role={tone === "info" ? "note" : "alert"} aria-label={label}>
      {Icon === null ? null : (
        <span className="banner__icon" aria-hidden="true">
          <Icon size={18} strokeWidth={2} />
        </span>
      )}
      <div className="banner__body">
        {title === undefined ? null : <strong>{title}</strong>}
        <div>{children}</div>
      </div>
      {action === undefined ? null : action}
    </div>
  );
}
